import { Controller } from "@hotwired/stimulus";
import SignaturePad from "signature_pad";

export default class extends Controller {
  static targets = ["canvas", "input"];

  connect() {
    this.signaturePad = new SignaturePad(this.canvasTarget);

    // Initialize with existing data if present
    if (this.inputTarget.value) {
      this.signaturePad.fromDataURL(this.inputTarget.value);
    }

    // Update hidden field whenever the user finishes a stroke or clicks
    this.signaturePad.addEventListener("endStroke", () => {
      this.save();
    });
  }

  save() {
    // Convert signature to data URL and save to hidden field
    this.inputTarget.value = this.signaturePad.toDataURL();
  }

  clear(event) {
    event.preventDefault();
    this.signaturePad.clear();
    this.inputTarget.value = "";
  }

  disconnect() {
    if (this.signaturePad) {
      this.signaturePad.off();
    }
  }
}
